import { authCacheIdentity } from "@/stores/auth-session";
import { useAuthStore } from "@/stores/auth.store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useLayoutEffect, useState, type ReactNode } from "react";

function SessionQueries({ children }: { children: ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 5 * 60 * 1000,
            retry: 1,
            refetchOnWindowFocus: false,
          },
        },
      }),
  );

  useLayoutEffect(
    () => () => {
      void client.cancelQueries();
      client.clear();
    },
    [client],
  );

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}

/** Remount private page state too: clearing query results alone leaves report drafts behind. */
export function AuthenticatedQueryProvider({
  children,
}: {
  children: ReactNode;
}) {
  const identity = useAuthStore(authCacheIdentity);
  return <SessionQueries key={identity}>{children}</SessionQueries>;
}
